<template>
  <div class="top-right-btn" :style="style">
    <el-row>
      <el-tooltip class="item" effect="dark" :content="showSearch ? '隐藏搜索' : '显示搜索'" placement="top"
                  v-if="search">
        <el-button circle icon="el-icon-search" size="small" @click="toggleSearch()"/>
      </el-tooltip>

      <el-tooltip class="item" effect="dark" content="刷新" placement="top">
        <el-button circle icon="el-icon-refresh" size="small" @click="refresh()"/>
      </el-tooltip>

      <el-tooltip class="item" effect="dark" content="显隐列" placement="top" v-if="Object.keys(columns).length > 0">
        <!--        <el-button circle icon="Menu" @click="showColumn()" v-if="showColumnsType == 'transfer'"/>-->
        <el-dropdown trigger="click" :hide-on-click="false" style="padding-left: 12px"
                     v-if="showColumnsType == 'checkbox'">
          <el-button circle icon="el-icon-menu" size="small"/>
          <template #dropdown>
            <el-dropdown-menu>
              <!-- 全选/反选 按钮 -->
              <el-dropdown-item>
                <el-checkbox v-model="isChecked" @change="toggleCheckAll"> 列展示
                </el-checkbox>
              </el-dropdown-item>
              <div class="check-line"></div>
              <div v-for="(item, key) in list" :key="item.key">
                <el-dropdown-item>
                  <el-checkbox v-model="item.visible" @change="checkboxChange($event, key)" :label="item.label"/>
                </el-dropdown-item>
              </div>
            </el-dropdown-menu>
          </template>
        </el-dropdown>
      </el-tooltip>
    </el-row>
  </div>
</template>
<script>
export default {
  name: "RightToolbar",
  props: {
    /* 是否显示检索条件 */
    showSearch: {
      type: Boolean,
      default: true
    },
    /* 显隐列信息（数组格式、对象格式） */
    columns: {
      type: [Array, Object],
      default: () => ({})
    },
    /* 是否显示检索图标 */
    search: {
      type: Boolean,
      default: true
    },
    /* 显隐列类型（transfer穿梭框、checkbox复选框） */
    showColumnsType: {
      type: String,
      default: "checkbox"
    },
    /* 右外边距 */
    gutter: {
      type: Number,
      default: 10
    },
    /* 列显隐状态记忆的 localStorage key（传入则启用记忆，不传则不记忆） */
    storageKey: {
      type: String,
      default: ""
    }
  },
  computed: {
    style() {
      const ret = {}
      if (this.gutter) {
        ret.marginRight = `${this.gutter / 2}px`
      }
      return ret
    },
    isIndeterminate() {
      Array.isArray(this.columns) ? this.columns.some((col) => col.visible) && !this.isChecked : Object.values(this.columns).some((col) => col.visible) && !this.isChecked
    }
  },
  data() {
    return {
      list: [],
      isChecked: true
    };
  },
  watch: {
    columns: {
      handler: function (to, from) {
        this.$nextTick(() => {
          this.list = to
          this.getIsChecked()
        })
      },
      // 如果需要在路由变化时立即响应，可以设置immediate为true
      immediate: true,
    },
  },
  methods: {
    getIsChecked() {
      this.isChecked = Array.isArray(this.list) ? this.list.every(col => col.visible) : Object.values(this.list).every((col) => col.visible)
    },
    saveStorage() {
      if (!this.storageKey) return
      try {
        let state = {}
        if (Array.isArray(this.columns)) {
          this.columns.forEach((col, index) => {
            state[index] = col.visible
          })
        } else {
          Object.keys(this.columns).forEach(key => {
            state[key] = this.columns[key].visible
          })
        }
        // cache.local.setJSON(this.storageKey, state)
      } catch (e) {
      }
    },
    checkboxChange(event, key) {
      this.$emit('getColumns', this.list)
      this.getIsChecked()
      // this.saveStorage()
    },
    toggleCheckAll() {
      if (Array.isArray(this.list)) {
        this.list.forEach((col) => (col.visible = this.isChecked))
      } else {
        Object.values(this.list).forEach((col) => (col.visible = this.isChecked))
      }
      this.$emit('getColumns', this.list)
      // this.saveStorage()
    },
    refresh() {
      this.$emit("queryTable")
    },
    toggleSearch() {
      this.$emit('update:showSearch', !this.showSearch)
    }
  }
}
</script>

<style scoped lang="less">
/* 表格右侧工具栏样式 */
.top-right-btn {
  margin-left: auto;
}
</style>
